import { combineReducers } from 'redux';

/* Reducers */
import accountDriver from './account_driver/';
import accountExtendedProperty from './account_extended_property/';
import accountGeozone from './account_geozone/';
import accountList from './account_list/';
import accountSemiTrailer from './account_semi_trailer/';
import accountSetting from './account_setting/';
import accountTag from './account_tag/';
import accountUser from './account_user/';
import accountVehicle from './account_vehicle/';
import accountWorkingShiftGroup from './account_working_shift_group/';
import allocator from './allocator/';
import assignmentList from './assignment_list/';
import dashboard from './dashboard/';
import datasource from './datasource/';
import detail_behaviour from './detail_behaviour/';
import detail_roadwarning from './detail_roadwarning/';
import detailFatigue from './detail_fatigue/';
import detailFulfillment from './detail_fulfillment/';
import detailInspection from './detail_inspection/';
import detailNfa from './detail_nfa/';
import detailTruck from './detail_truck/';
import detailWaitingTimes from './detail_waiting_times/';
import driverBehavior from './driver_behavior/';
import driverFatigue from './driver_fatigue/';
import driverFulfillment from './driver_fulfillment/';
import driverNfa from './driver_nfa/';
import driverRecord from './driver_record/';
import driverRoadwarning from './driver_roadwarning/';
import dynamicList from './dynamic_list';
import flowAdminDetail from './flow_admin_detail/';
import flowAdminRcaReports from './flow_admin_rca_reports/';
import flowApplicantDetail from './flow_applicant_detail/';
import flowsHistory from './flows_history/';
import geozones from './common/geozones/';
import header from './header/';
import homologationDriver from './homologation_driver/';
import homologationSemiTrailer from './homologation_semi_trailer/';
import homologationVehicle from './homologation_vehicle/';
import lastDataFfdPvt from './last_data_ffd_pvt/';
import lastDataFfdSleep from './last_data_ffd_sleep/';
import login from './login/';
import nav from './nav/';
import summaryBehaviour from './summary_behaviour/';
import summaryFatigue from './summary_fatigue/';
import summaryFfdPvt from './summary_ffd_pvt/';
import summaryFfdSleep from './summary_ffd_sleep/';
import summaryFulfillment from './summary_fulfillment/';
import summaryInspections from './summary_inspections/';
import summaryNfa from './summary_nfa/';
import summaryRoadwarning from './summary_roadwarning/';
import summaryTruck from './summary_truck/';
import survey from './survey/';
import tags from './common/tags/';
import tasksManager from './tasks_manager/';
import tasksManagerTabNotifications from './tasks_manager_tab_notifications';
import tasksManagerTabTasks from './tasks_manager_tab_tasks';
import userProfile from './user_profile/';
import workingShiftGroups from './common/working_shift_groups/';

const reducer = combineReducers({
  accountDriver,
  accountExtendedProperty,
  accountGeozone,
  accountList,
  accountSemiTrailer,
  accountSetting,
  accountTag,
  accountUser,
  accountVehicle,
  accountWorkingShiftGroup,
  allocator,
  assignmentList,
  dashboard,
  datasource,
  detail_behaviour,
  detail_roadwarning,
  detailFatigue,
  detailFulfillment,
  detailInspection,
  detailNfa,
  detailTruck,
  detailWaitingTimes,
  driverBehavior,
  driverFatigue,
  driverFulfillment,
  driverNfa,
  driverRecord,
  driverRoadwarning,
  dynamicList,
  flowAdminDetail,
  flowAdminRcaReports,
  flowApplicantDetail,
  flowsHistory,
  geozones,
  header,
  homologationDriver,
  homologationSemiTrailer,
  homologationVehicle,
  lastDataFfdPvt,
  lastDataFfdSleep,
  login,
  nav,
  summaryBehaviour,
  summaryFatigue,
  summaryFfdPvt,
  summaryFfdSleep,
  summaryFulfillment,
  summaryInspections,
  summaryNfa,
  summaryRoadwarning,
  summaryTruck,
  survey,
  tags,
  tasksManager,
  tasksManagerTabNotifications,
  tasksManagerTabTasks,
  userProfile,
  workingShiftGroups,
});

export default reducer;



// WEBPACK FOOTER //
// ./source/client/reducers/index.js